import { axiosToken, simpleAxios } from "@/utils/http";
import type { AxiosResponse } from "axios";
import type { List } from "lodash";
import { defineStore, acceptHMRUpdate } from "pinia"
import { useTapasStore } from "./tapas";
import type { TapasChallenge } from "./interfaces/tapas_interfaces";
import { translate, translateAll } from "@/utils/translate";
import { useEventsStore } from "./events";
import { useContentStore } from "./content";

interface Budget_Line {
    id:Number,
    name:String,
    pax:Number,
	price_tag?:String,
	activity:String | Number,
	budget_type?:String,
	order_id?:Number,
	type?:String,
	description?:String,
	price?:Number | String,
	event_service?:Number | String,
	options_tags?:any[],
	custom_price?:any,

}

function sortBudgetLinesByOrder(lines: Budget_Line[]): Budget_Line[] {
	return [...lines].sort((a, b) => {
		const orderA = Number(a.order_id) || Number.MAX_SAFE_INTEGER
		const orderB = Number(b.order_id) || Number.MAX_SAFE_INTEGER
		if (orderA !== orderB) {
			return orderA - orderB
		}
		return Number(a.id) - Number(b.id)
	})
}

function getNextBudgetLineOrderId(lines: Budget_Line[]): number {
	if (!lines.length) {
		return 1
	}
	return Math.max(...lines.map((line) => Number(line.order_id) || 0)) + 1
}

export const useBudgetStore = defineStore("budget", {
	state: () => ({
		budgets:[],
		budget_lines:[] as Budget_Line[],
		extras: [],
		budget_page: [],
		currency:""
	}),
	actions: {
		async setDefault()
		{
			this.budgets = []
			this.budget_lines = [] as Budget_Line[]
			this.extras = []
			this.budget_page = []
		},
        async fetchBudgets(params?: { dateRange?: [Date | null, Date | null] | null; filters?: any, date_field?: string, compact?: boolean }){
			// Helper function to format date as YYYY-MM-DD using local time (not UTC)
			const formatDateLocal = (date: Date): string => {
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				return `${year}-${month}-${day}`;
			};

			// Build query parameters
			const queryParams: any = {};
			
			// Add date range if provided and both dates are set
			if (params?.dateRange && params.dateRange[0] && params.dateRange[1]) {
				// Format dates using local time to avoid timezone conversion issues
				queryParams.date_from = formatDateLocal(params.dateRange[0]);
				queryParams.date_to = formatDateLocal(params.dateRange[1]);
				queryParams.date_field = params.date_field || "date";
			}
			if (params?.compact) {
				queryParams.compact = 1;
			}
			
			await axiosToken("get", "budget/budgets/", queryParams)
			.then((response: AxiosResponse) => {
				this.budgets = response.data
			})
			.catch((e: any) => {
				console.log(e);
			});
        },
		async fetchBudgetLine(budget:String){
			await axiosToken("get","budget/budget_line/" + budget +"/").then((response)=>{
				this.budget_lines = sortBudgetLinesByOrder(response.data)
			})
		},
		sortBudgetLinesByOrder(lines: Budget_Line[] = this.budget_lines) {
			return sortBudgetLinesByOrder(lines)
		},
		getNextBudgetLineOrderId() {
			return getNextBudgetLineOrderId(this.budget_lines)
		},
		applyOrderIdsAfterReorder() {
			this.budget_lines.forEach((line, index) => {
				line.order_id = index + 1
			})
		},
		
	
		


		
	},
	persist: {
		// paths: ["events"]
	},
	getters:{
		getOptionsTagsEventService:  state => (eventService: number) => {
			// NEED ACTIVITY FROM THE OTHER STORE
			const contentStore = useContentStore();
			const eventServiceData = contentStore.getContentByTypeById("eventService", eventService)
			const tags = []
			if( Array.isArray(eventServiceData.price))
			{
				eventServiceData.price.forEach(e =>{
					tags.push({
						value:e.name,
						label:e.name
					})
				})

			}
			return tags.sort((a, b) => String(a.label).localeCompare(String(b.label), undefined, { sensitivity: 'base' }))
		},

		getOptionsTags:  state => (activity: number) => {
			// NEED ACTIVITY FROM THE OTHER STORE
			const contentStore = useContentStore();
			const activityData = contentStore.getContentByTypeById("activity", activity)
			const tags = []
			if( Array.isArray(activityData.price_rules))
			{
				activityData.price_rules.forEach(e =>{
					tags.push({
						value:e.name,
						label:e.name
					})
				})

			}
			return tags.sort((a, b) => String(a.label).localeCompare(String(b.label), undefined, { sensitivity: 'base' }))
		},
		getPricingEventService:state =>(eventService: number, pax:number, tag:String)=>{
			const contentStore = useContentStore();
			const eventServiceData = contentStore.getContentByTypeById("eventService", eventService)
			let price = 0;
			console.log(tag, eventServiceData.price);
			if(tag == 'Custom')
			{
				return tag
			}
			if( Array.isArray(eventServiceData.price))
			{
				const priceArray = eventServiceData.price.find(e=> e.name == tag)
				price = priceArray
			}
			console.log(price);
			return price;
		},
		getPricing:state =>(activity: number, pax:number, tag:String)=>{
			// NEED ACTIVITY FROM THE OTHER STORE
			const contentStore = useContentStore();
			const activityData = contentStore.getContentByTypeById("activity", activity)
			let price = 0;

			if(tag == 'Custom')
			{
				return price
			}

			if( Array.isArray(activityData.price_rules))
			{
				console.log("INNNNNN")
				const priceArray = activityData.price_rules.find(e=> e.name == tag)
				for (let index = 0; index < priceArray.list.length; index++) {
					const element = priceArray.list[index];
					console.log(element);
					
					if(pax >=  parseInt(element.pax_low)  && pax <= parseInt(element.pax_high))
					{
						price = element.price_total
						break;
					}
				}
			}
			console.log(pax,price);
			return price; 
		},
		getPaxInterval:state =>(activity: number, tag:String)=>{
			const contentStore = useContentStore();
			const activityData = contentStore.getContentByTypeById("activity", activity)
			const tagPax = []

			if(tag == 'Custom')
			{
				return ''
			}

			if( Array.isArray(activityData.price_rules))
			{
				const priceArray = activityData.price_rules.find(e=> e.name == tag)
				for (let index = 0; index < priceArray.list.length; index++) {
					const element = priceArray.list[index];
					tagPax.push({
						"label": element.pax_low + ' - ' + element.pax_high,
						"value": index,
					})
				}
			}
			return tagPax
		},
		getPriceByIndex:state =>(activity: number, index:number, tag:String)=>{
			const contentStore = useContentStore();
			const activityData = contentStore.getContentByTypeById("activity", activity)
			let price = 0;
			if( Array.isArray(activityData.price_rules))
			{
				const priceArray = activityData.price_rules.find(e=> e.name == tag)
				price = priceArray.list[index].price_total
			}
			console.log(price);
			return price; 
		}
	}
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useBudgetStore, import.meta.hot))
}
